// extracted by mini-css-extract-plugin
export default {"table":"DepartmentListingTable-module__table__u0dSp","link":"DepartmentListingTable-module__link__gqysI"};